<div class="partner-details-nav">
    <button type="button" (click)="onNavigateBack()">
        <mat-icon>arrow_back_ios</mat-icon>
        <span>Vissza</span>
    </button>
</div>
<!-- @if (getPartnerDetailsResponse) { -->
<div class="partner-details-container">
    <div class="partner-details">
        <div class="partner-table-title">
            <button type="button" (click)="onAddNewCommissionToPartner()">
                <mat-icon>add_circle_outline</mat-icon>
                <span>Új jutalék felvétele</span>
            </button>
            <h3>Partner Jutalék</h3>
        </div>
        @if (isMobile()) {
            <div id="card-container">
                @for (commission of getPartnerDetailsResponse.partnerCommissions; track commission; let i = $index) {
                    <pf-card
                        [id]="'partner-commission-id-' + commission.commissionId"
                        [itemId]="i"
                        [itemTitle]="commission.name"
                        [itemSubTitle]="commission.productName"
                        [itemContent]="commission.partnerName"
                        [itemQuantity]="`${commission.percentage}%`"
                        [itemDate]="commission.startDate"
                        (closeCard)="onRemoveCommissionClicked(commission)"
                        (editCard)="onEditPartnerCommissionDetails(commission)"
                    />
                }
            </div>
        } @else {
            <table>
                <thead>
                    <th>Jutalék megnevezése</th>
                    <th>Partner Neve</th>
                    <th>Termék megnevezése</th>
                    <th>Százalék</th>
                    <th>Kezdeti dátum</th>
                    <th></th>
                </thead>
                @for (commission of getPartnerDetailsResponse.partnerCommissions; track commission; let i = $index) {
                    <tr class="clickable-row">
                        <a class="partner-details-link" tabindex="0" role="button" (click)="onEditPartnerCommissionDetails(commission)">
                            <td>{{ commission.name }}</td>
                        </a>
                        <td>{{ commission.partnerName }}</td>
                        <td>{{ commission.productName }}</td>
                        <td>{{ commission.percentage }}</td>
                        <td>{{ commission.startDate | dateUtil }}</td>
                        <td class="action-column">
                            <button class="delete" type="button" (click)="onRemoveCommissionClicked(commission)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </tr>
                }
            </table>
        }
    </div>
    <div class="partner-details">
        <div class="partner-table-title">
            <button type="button" (click)="onAddNewOnSalePeriodToPartner()">
                <mat-icon>add_circle_outline</mat-icon>
                <span>Új akció felvétele</span>
            </button>
            <h3>Partner Akciós Időszak</h3>
        </div>
        @if (isMobile()) {
            <div id="card-container">
                @for (onSalePeriod of getPartnerDetailsResponse.partnerOnSalePeriods; track onSalePeriod; let i = $index) {
                    <pf-card
                        [id]="'partner-commission-id-' + onSalePeriod.onSalePeriodId"
                        [itemId]="i"
                        [itemTitle]="onSalePeriod.name"
                        [itemSubTitle]="onSalePeriod.productName"
                        [itemContent]="onSalePeriod.partnerName"
                        [itemQuantity]="`${onSalePeriod.percentage}%`"
                        [itemDate]="onSalePeriod.startDate"
                        (closeCard)="onRemoveCommissionClicked(onSalePeriod)"
                        (editCard)="onEditPartnerCommissionDetails(onSalePeriod)"
                    />
                }
            </div>
        } @else {
            <table>
                <thead>
                    <th>Akció megnevezése</th>
                    <th>Partner Neve</th>
                    <th>Termék megnevezése</th>
                    <th>Százalék</th>
                    <th>Kezdeti dátum</th>
                    <th>Vég dátum</th>
                    <th></th>
                </thead>
                @for (onSalePeriod of getPartnerDetailsResponse.partnerOnSalePeriods; track onSalePeriod; let i = $index) {
                    <tr class="clickable-row">
                        <a class="partner-details-link" tabindex="0" role="button" (click)="onEditPartnerOnSalePeriodDetails(onSalePeriod)">
                            <td>{{ onSalePeriod.name }}</td>
                        </a>
                        <td>{{ onSalePeriod.partnerName }}</td>
                        <td>{{ onSalePeriod.productName }}</td>
                        <td>{{ onSalePeriod.percentage }}</td>
                        <td>{{ onSalePeriod.startDate | dateUtil }}</td>
                        <td>{{ onSalePeriod.endDate | dateUtil }}</td>
                        <td class="action-column">
                            <button class="delete" type="button" (click)="onRemoveOnSalePeriodClicked(onSalePeriod)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </tr>
                }
            </table>
        }
    </div>
</div>
<!-- } -->
